import type { AuthUser } from '@/types/auth';

export function isInRedemption(user: AuthUser): boolean {
  if (user.account_status !== 'redemption_test') return false;
  if (!user.redemption_ends_at) return false;
  return new Date(user.redemption_ends_at) > new Date();
}

// Eligibility for the Game Over redemption block.
// "Was previously healthy" is derived from test_passed_at != null — the only
// path into healthy goes through the test phase, so the timestamp is the
// authoritative signal without needing a dedicated boolean field.
export function canStartRedemption(user: AuthUser): boolean {
  if (user.account_status !== 'banned') return false;
  if (user.has_used_redemption) return false;
  return !!user.test_passed_at;
}

export function hasRedeemedSuccessfully(user: AuthUser): boolean {
  return !!user.has_used_redemption && !!user.redemption_passed_at;
}
